<div class="lecont" style="min-height: 100%;" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}">
  <div style="padding-bottom: 4em;">
    <div class="wizards" style="width: 80%; height: auto; padding: 0;">
      <app-reports-wizard *ngIf="createTonnageReportWizOpen && !isDownloading"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [reportTitle]="reportTitle"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [contactSvc]="contactSvc"
        [jobSvc]="jobSvc"
        [sthSvc]="sthSvc"
        [appGlobals]="appGlobals"
        [sbSvcProvider]="sbSvcProvider"
        [isSeasonal]="isSeasonal"
        [warnForDateRange]="warnForDateRange()"
        (wizardCompletedEmitter)="handleTonnageReportWizard($event)"
        (wizardCancelledEmitter)="handleTonnageReportWizard($event)">
        Generate Custom Tonnage Report
      </app-reports-wizard>
    </div>

    <div class="wizards" style="width: 80%; height: auto; padding: 0;">
      <app-reports-wizard *ngIf="createQuantityReportWizOpen && !isDownloading"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [reportTitle]="reportTitle"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [contactSvc]="contactSvc"
        [jobSvc]="jobSvc"
        [sthSvc]="sthSvc"
        [appGlobals]="appGlobals"
        [sbSvcProvider]="sbSvcProvider"
        [isSeasonal]="isSeasonal"
        [warnForDateRange]="warnForDateRange()"
        (wizardCompletedEmitter)="handleMatQtySummaryReportWizard($event)"
        (wizardCancelledEmitter)="handleMatQtySummaryReportWizard($event)">
        Generate Custom Material Quantity Summary Report
      </app-reports-wizard>
    </div>

    <div class="wizards" style="width: 80%; height: auto; padding: 0; outline: solid; outline-offset: 0px;" *ngIf="createInvoiceReportWizOpen">
      <div class = "wrapper" [ngClass]="{'darkMode': darkMode}" style="width: 100%; height: auto; position: relative; background: white;">
        <app-reports-invoice-wizard
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [contactSvc]="contactSvc"
        [jobSvc]="jobSvc"
        [sthSvc]="sthSvc"
        [appGlobals]="appGlobals"
        [isSingleSelectMode] = "true"
        [sbSvcProvider]="sbSvcProvider"
        (wizardCompletedEmitter)="handleInvoiceReportWizard($event)"
        (wizardCancelledEmitter)="handleInvoiceReportWizard($event)">
        </app-reports-invoice-wizard>
      </div>
    </div>

    <div class="wizards" style="width: 80%; height: auto; padding: 0; outline: solid; outline-offset: 0px; display: flex;" *ngIf="createTransactionReportWizOpen">
      <div class="wrapper" [ngClass]="{'darkMode': darkMode}" style="width: 100%; height: auto; min-height: 300px; position: relative; background: white;">
        <lib-transaction-report-wizard *ngIf="createTransactionReportWizOpen"
          [contactSvc]="contactSvc"
          [appGlobals]="appGlobals"
          [sbSvcProvider]="sbSvcProvider"
          (wizardCompletedEmitter)="handleTransactionReportWizard($event)"
          (wizardCancelledEmitter)="handleTransactionReportWizard($event)">
        </lib-transaction-report-wizard>
      </div>
    </div>

    <div class="wizards" [ngClass]="{'darkMode': darkMode}"
      style="width: 90%; min-width: 550px; height: auto;  left: 50% !important; border: solid; text-align: center; display: flex; flex-direction: column; background: white;"
      *ngIf="datePickerModalForInvoiceOpen">
      <div class="topPaneHolder">
        <div style="justify-content: center;">
          <h1 style="padding-top: 1em;"><i class="fal fa-file-invoice-dollar"></i>
            Custom Invoice Report
          </h1>
        </div>
        <div style=" top: 10px; right: 10px; position: absolute;">
          <button [matTooltip]="'Close'" (click)="closeInvoiceDatePicker()" class="btn" [ngClass]="{'btn-dark':darkMode, 'btn-outline-secondary': !darkMode}">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="row" [ngClass]="{'darkMode': darkMode}" style="justify-content: center; margin: 0.25em;">
        <div class="form-inline form-group">
          <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
            <label for="loadingToggle2" class="btn btn-sm btn-light"
              [ngClass]="{'active': singleInvoice, 'inactive': !singleInvoice, 'btn-dark': darkMode}"
              (click)="singleInvoice = true; singleCustomer = false; forAllCustomers = false;">Single Invoice Report&nbsp;
            </label>
            <label for="loadingToggle" class="btn btn-sm btn-light"
              [ngClass]="{'active': singleCustomer, 'inactive': !singleCustomer, 'btn-dark': darkMode}"
              (click)="singleInvoice = false; singleCustomer = true; forAllCustomers = false;">&nbsp;Single Customer Report&nbsp;
            </label>
            <label for="loadingToggle3" class="btn btn-sm btn-light"
              [ngClass]="{'active': forAllCustomers, 'inactive': !forAllCustomers, 'btn-dark': darkMode}"
              (click)="singleInvoice = false; singleCustomer = false; forAllCustomers = true;">&nbsp;All Customers Report
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="forAllCustomers" class="wrapper" [ngClass]="{'darkMode': darkMode}" style="width: 100%; height: auto; position: relative; padding-top: 1.5em;">
        <span> <b>Select a Date Range</b></span>
        <div class="input-group" style="width: 25em; margin: auto; margin-bottom: 2em;">
          <input
            [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (filterDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
            placeholder="Date Range" id="dateRange" name="dateRange" #filterDateRange bsDaterangepicker
            [bsConfig]="bsConfig" (bsValueChange)="dateRangeChangeForInvoices($event)" class="form-control"
            [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

          <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
            (click)="filterDateRange.click()">
            <i class="fas fa-calendar-week fa-lg"></i>
          </button>

          <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button"
            (click)="filterDateFrom = null; filterDateTo = null;">
            <i class="fad fa-calendar fa-lg"></i>
          </button>

        </div>

        <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
          <div style="min-width: 750px; text-align: center;">
            <span style="color: red;" *ngIf="displayDateRangeWarning(filterDateFrom, filterDateTo)">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</span>
          </div>
        </div>
      </div>
      <div *ngIf="singleCustomer" class="mt-4">
        <span> <b>Select a Date Range</b></span>
        <div class="input-group" style="width: 25em; margin: auto; margin-bottom: 2em;">
          <input
            [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (filterDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
            placeholder="Date Range" id="dateRange" name="dateRange" #filterDateRange bsDaterangepicker
            [bsConfig]="bsConfig" (bsValueChange)="dateRangeChangeForInvoices($event)" class="form-control"
            [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

          <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
            (click)="filterDateRange.click()">
            <i class="fas fa-calendar-week fa-lg"></i>
          </button>

          <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button"
            (click)="filterDateFrom = null; filterDateTo = null;">
            <i class="fad fa-calendar fa-lg"></i>
          </button>

        </div>
        <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
          <div style="min-width: 750px; text-align: center;">
            <span style="color: red;" *ngIf="displayDateRangeWarning(filterDateFrom, filterDateTo)">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</span>
          </div>
        </div>
        <div style="width: 90%; min-width: 500px; margin: auto; margin-bottom: 2em;">
          <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
            <div title="Please wait..." class="ball-pulse">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <lib-customer-select #customerSelect *ngIf="!isProcessing"
                    [darkMode]="darkMode"
                    [currentCustomers]="customers"
                    [dateRange]="!showAll ? [] : (!filterDateFrom || !filterDateTo) ? undefined : [filterDateFrom, filterDateTo]"
                    [batchMode]="false"
                    [customerSvc]="contactSvc"
                    [isReport]="true"
                    (selectionEmitter)="selectCustomer($event)"
                    [currentCustomer]="customer"
                    (hardSelectionEmitter)="selectCustomer($event, true); customInvoiceReportValid()? generateCustomInvoiceReport(): filterDateRange.focus();">
                    Select Customer for Invoice Report
          </lib-customer-select>
        </div>
      </div>
      <div *ngIf="singleInvoice">
        <div class = "wrapper dashModule" [ngClass]="{'darkMode': darkMode}" style="position: relative; width: 90%; min-width: 500px; margin: auto; margin-bottom: 2em; padding: 0em;">
          <lib-invoice-select style="margin-top: -0.3em; display: block;"
            [mainColor]=""
            [darkMode]="darkMode"
            [ngClass]="{'darkMode': darkMode}"
            [tooltipDelay]="tooltipDelay"
            [currentInvoices]="selectedInvoices"
            [selectedJob]="job"
            [glassMode]="glassMode"
            [invoiceSvc]="invoiceSvc"
            [appGlobals]="appGlobals"
            [batchMode]="false"
            [selectedInvoice]="selectedInvoice"
            (selectionEmitter)="selectInvoice($event)"
            (hardSelectionEmitter)="generateInvoiceReportSingleSelect($event)">
            Invoice Report by Invoice
          </lib-invoice-select>
        </div>
      </div>

      <div class="btn-group w-100" role="group">
        <button class="btn btn-outline-warning  no-radius" type="button" (click)="closeInvoiceDatePicker()">
          <i class="fal fa-times"></i>
          Close
        </button>
        <button class="btn btn-success  no-radius"  [disabled]="!customInvoiceReportValid()"
          type="button"
          (click)="generateCustomInvoiceReport()">
          <i class="fal fa-check"></i>
          Generate
        </button>
      </div>
    </div>


    <div class="wizards" [ngClass]="{'darkMode': darkMode}"
      style="width: 90%; min-width: 550px; height: auto;  left: 50% !important; border: solid; text-align: center; display: flex; flex-direction: column; background: white;"
      *ngIf="invoiceAgingDetailModalOpen">
      <div class="topPaneHolder">
        <div style="justify-content: center;">
          <h1 style="padding-top: 1em;"><i class="fal fa-file-invoice-dollar"></i>
            Custom Invoice Aging Detail Report
          </h1>
        </div>
        <div style=" top: 10px; right: 10px; position: absolute;">
          <button [matTooltip]="'Close'" (click)="closeInvoiceAgingDetailDatePicker()" class="btn" [ngClass]="{'btn-dark':darkMode, 'btn-outline-secondary': !darkMode}">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="row" [ngClass]="{'darkMode': darkMode}" style="justify-content: center; margin: 0.25em;">
        <div class="form-inline form-group">
          <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
            <label for="loadingToggle" class="btn btn-sm btn-light"
              [ngClass]="{'active': singleCustomer, 'inactive': !singleCustomer, 'btn-dark': darkMode}"
              (click)="singleInvoice = false; singleCustomer = true; forAllCustomers = false;">&nbsp;Single Customer Report&nbsp;
            </label>
            <label for="loadingToggle3" class="btn btn-sm btn-light"
              [ngClass]="{'active': forAllCustomers, 'inactive': !forAllCustomers, 'btn-dark': darkMode}"
              (click)="singleInvoice = false; singleCustomer = false; forAllCustomers = true;">&nbsp;All Customers Report&nbsp;
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="forAllCustomers" class="wrapper" [ngClass]="{'darkMode': darkMode}" style="width: 100%; height: auto; position: relative; padding-top: 1.5em;">
      </div>
      <div *ngIf="singleCustomer">
        <div style="width: 90%; min-width: 500px; margin-left: 5%; margin-bottom: 2em;">
          <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
            <div title="Please wait..." class="ball-pulse">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <lib-customer-select #customerSelect *ngIf="!isProcessing"
                    [darkMode]="darkMode"
                    [currentCustomers]="customers"
                    [dateRange]="!showAll ? [] : (!filterDateFrom || !filterDateTo) ? undefined : [filterDateFrom, filterDateTo]"
                    [batchMode]="false"
                    [customerSvc]="contactSvc"
                    [isReport]="true"
                    [currentCustomer]="customer"
                    (selectionEmitter)="selectCustomer($event)"
                    (hardSelectionEmitter)="selectCustomer($event, true); generateInvoiceAgingDetailReport()">
                    Select Customer for Invoice Report
          </lib-customer-select>
        </div>
      </div>
      <div class="btn-group w-100" role="group">
        <button class="btn btn-outline-warning  no-radius"  type="button" (click)="closeInvoiceAgingDetailDatePicker()">
          <i class="fal fa-times"></i>
          Close
        </button>
        <button class="btn btn-success no-radius" [disabled]="(this.customer == undefined || this.customer == null) && this.singleCustomer"
          type="button" (click)="generateInvoiceAgingDetailReport()">
          <i class="fal fa-check"></i>
          Generate
        </button>
      </div>
    </div>

    <div class="wizards" [ngClass]="{'darkMode': darkMode}"
      style="width: 90%; min-width: 550px; height: auto;  left: 50% !important; border: solid; text-align: center; display: flex; flex-direction: column; background: white;"
      *ngIf="customerStatementModalOpen">
      <div class="topPaneHolder">
        <div style="justify-content: center;">
          <h1 style="padding-top: 1em;"><i class="fal fa-file-invoice-dollar"></i>
            Customer Statement Report
          </h1>
        </div>
        <div style=" top: 10px; right: 10px; position: absolute;">
          <button [matTooltip]="'Close'" (click)="closeCustomerStatement()" class="btn" [ngClass]="{'btn-dark':darkMode, 'btn-outline-secondary': !darkMode}">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <div *ngIf="forAllCustomers" class="wrapper" [ngClass]="{'darkMode': darkMode}" style="width: 100%; height: auto; position: relative; padding-top: 1.5em;">
        <span> <b>Select a Date Range</b></span>

        <div class="input-group" style="width: 25em; margin: auto; margin-bottom: 2em;">
          <input
            [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (filterDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
            placeholder="Date Range" id="dateRange" name="dateRange" #filterDateRange bsDaterangepicker
            [bsConfig]="bsConfig" (bsValueChange)="dateRangeChangeForInvoices($event)" class="form-control"
            [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

          <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
            (click)="filterDateRange.click()">
            <i class="fas fa-calendar-week fa-lg"></i>
          </button>

          <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button"
            (click)="filterDateFrom = null; filterDateTo = null;">
            <i class="fad fa-calendar fa-lg"></i>
          </button>

        </div>

        <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
          <div style="min-width: 750px; text-align: center;">
            <span style="color: red;" *ngIf="displayDateRangeWarning(filterDateFrom, filterDateTo)">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</span>
          </div>
        </div>
      </div>
      <div *ngIf="singleCustomer">
        <div style="width: 90%; min-width: 500px; margin-left: 5%; margin-bottom: 2em;">
          <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
            <div title="Please wait..." class="ball-pulse">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <lib-customer-select #customerSelect *ngIf="!isProcessing"
                    [darkMode]="darkMode"
                    [currentCustomers]="customers"
                    [dateRange]="!showAll ? [] : (!filterDateFrom || !filterDateTo) ? undefined : [filterDateFrom, filterDateTo]"
                    [batchMode]="false"
                    [customerSvc]="contactSvc"
                    [isReport]="true"
                    [currentCustomer]="customer"
                    (selectionEmitter)="selectCustomer($event)"
                    (hardSelectionEmitter)="selectCustomer($event, true); generateCustomerStatementReport()">
                    Select Customer for Invoice Report
          </lib-customer-select>
        </div>
      </div>
      <div class="btn-group w-100" role="group">
        <button class="btn btn-outline-warning" type="button" (click)="closeCustomerStatement()">
          <i class="fal fa-times"></i>
          Close
        </button>
        <button class="btn btn-success" [disabled]="this.customer == null || this.customer == undefined"
          type="button" (click)="generateCustomerStatementReport()">
          <i class="fal fa-check"></i>
          Generate
        </button>
      </div>
    </div>

    <div class="wizards" [ngClass]="{'darkMode': darkMode}" style="width: 75%; height: auto; padding: 1em; border: solid; background: white;
      display: flex; flex-direction: column; outline-offset: 0px;" *ngIf="singleInvoiceReportMode && !closeInvoiceSelectorBool">
      <div class = "topPaneHolder">
        <div style="justify-content: center; text-align: center;">
          <h1 style="padding-top: 1em;"></h1>
        </div>

        <div style=" top: 10px; right: 10px; position: absolute;">
          <button [matTooltip]="'Close'" (click)="closeInvoiceSelector()" class="btn" [ngClass]="{'btn-dark':darkMode, 'btn-outline-secondary': !darkMode}">
            <i class="fas fa-times"></i>
          </button>
        </div>

      </div>
      <div class = "wrapper" [ngClass]="{'darkMode': darkMode}" style="position: relative;">
        <lib-invoice-select
          [mainColor]=""
          [darkMode]="darkMode"
          [ngClass]="{'darkMode': darkMode}"
          [tooltipDelay]="tooltipDelay"
          [currentInvoices]="selectedInvoices"
          [selectedJob]="job"
          [glassMode]="glassMode"
          [invoiceSvc]="invoiceSvc"
          [appGlobals]="appGlobals"
          [batchMode]="false"
          (selectionEmitter)="selectInvoice($event)"
          (hardSelectionEmitter)="generateInvoiceReportSingleSelect($event)">
          Invoice Report by Invoice Number
        </lib-invoice-select>
        <div style = "display: flex; justify-content: right;">
          <button class="btn btn-outline-warning"
            type="button" (click)="closeInvoiceSelector()">
            <i class="fal fa-times"></i>
            Close
          </button>
          <button class="btn btn-outline-success"  [disabled]="!selectedInvoice"
            type="button"
            (click)="generateInvoiceReportSingleSelect('generateClicked')">
            <i class="fal fa-check"></i>
            Generate
          </button>
        </div>
      </div>
    </div>

    <!-- Favorite Reports Start -->
    <div *ngIf="hasFavorites" style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseFavorites}">
      <div style="text-align: center; margin: 1em;">
        <h1><i class="fas fa-star" style="color: gold;"></i> Favorite Reports</h1>
      </div>
      <button class="btn btn-sm" [ngClass]="{'darkMode': darkMode}" style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;" (click)="collapseFavorites = !collapseFavorites;">
        <i class="fal" [ngClass]="{'fa-angle-up': collapseFavorites, 'fa-angle-down': !collapseFavorites}"></i>
      </button>
      <hr>

      <div class="container" style="max-width: 93%;">
        <div class="reports-grid">
          <ng-container *ngFor="let favoriteId of favoriteReports">
            <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: favoriteId, isFavoriteSection: true }"></ng-container>
          </ng-container>
        </div>
      </div>

      <br>
    </div>
    <!-- Favorite Reports End -->

    <!-- Tonnage Reports Start SECTION -->
      <div style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseTonnage}">
      <div style="text-align: center; margin: 1em;">
        <h1>Tonnage Reports</h1>
      </div>
      <button class="btn btn-sm" [ngClass]="{'darkMode': darkMode}" style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;" (click)="collapseTonnage = !collapseTonnage;"><i class="fal" [ngClass]="{'fa-angle-up': collapseTonnage, 'fa-angle-down': !collapseTonnage}"></i></button>
      <hr>

      <div class="container" style="max-width: 93%;">

        <div class="reports-grid">

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'tonnage-summary', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'material-summary', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'detailed-tonnage', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'material-quantity', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'tonnage-by-customer', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'annual-tonnage', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'annual-grid-tonnage', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'seasonal-tonnage', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'seasonal-tonnage-excel', isFavoriteSection: false }"></ng-container>

        </div> <!-- end .reports-grid -->
      </div>
      <br>
    </div>
    <!-- Tonnage Reports End SECTION -->


    <!-- Tonnage Financial Reports Start SECTION -->
    <div style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseTonFinance}">
      <div style="text-align: center; margin: 1em;">
        <h1>Tonnage Financial Reports</h1>
      </div>
      <button class="btn btn-sm" [ngClass]="{'darkMode': darkMode}" style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;" (click)="toggleTonFinanceCollapse();">
        <i class="fal" [ngClass]="{'fa-angle-up': collapseTonFinance, 'fa-angle-down': !collapseTonFinance}"></i>
      </button>
      <hr>

      <div class="container" style="max-width: 93%;">
        <div class="reports-grid">

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'tonnage-financial-detail', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'comprehensive-material', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'annual-comp-tonnage', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'tonnage-excel', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'tonnage-summary-excel', isFavoriteSection: false }"></ng-container>

        </div>
      </div>
      <br>
    </div>
    <!-- Tonnage Financial Reports End SECTION -->


    <!-- Finance Reports Start SECTION -->
    <div style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseInvoice}">
      <div style="text-align: center; margin: 1em;">
        <h1>Finance Reports</h1>
      </div>
      <button class="btn btn-sm" [ngClass]="{'darkMode': darkMode}" style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;" (click)="collapseInvoice = !collapseInvoice;"><i class="fal" [ngClass]="{'fa-angle-up': collapseInvoice, 'fa-angle-down': !collapseInvoice}"></i></button>
      <hr>

      <div class="container" style="max-width: 93%;">
        <div class="reports-grid">
          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'detailed-invoice', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'transaction-report', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'invoice-aging', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'account-credit', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'customer-aging', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'invoice-aging-detail', isFavoriteSection: false }"></ng-container>

          <ng-container *ngTemplateOutlet="reportTemplate; context: { reportId: 'customer-statement', isFavoriteSection: false }"></ng-container>

        </div>
      </div>


      <br>
    </div>
    <!-- Finance Reports End SECTION -->

  <!-- Generic report template selector -->
   <ng-template #reportTemplate let-reportId="reportId" let-isFavoriteSection="isFavoriteSection">
    <ng-container [ngSwitch]="reportId">
      <ng-container *ngSwitchCase="'tonnage-summary'">
        <ng-container *ngTemplateOutlet="tonnageSummaryTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'material-summary'">
        <ng-container *ngTemplateOutlet="materialSummaryTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'detailed-tonnage'">
        <ng-container *ngTemplateOutlet="detailedTonnageTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'material-quantity'">
        <ng-container *ngTemplateOutlet="materialQuantityTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'tonnage-by-customer'">
        <ng-container *ngTemplateOutlet="tonnageByCustomerTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'annual-tonnage'">
        <ng-container *ngTemplateOutlet="annualTonnageTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'annual-grid-tonnage'">
        <ng-container *ngTemplateOutlet="annualGridTonnageTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'annual-comp-tonnage'">
        <ng-container *ngTemplateOutlet="annualCompTonnageReport; contect: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'seasonal-tonnage'">
        <ng-container *ngTemplateOutlet="seasonalTonnageTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'seasonal-tonnage-excel'">
        <ng-container *ngTemplateOutlet="seasonalTonnageExcelTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'tonnage-financial-detail'">
        <ng-container *ngTemplateOutlet="tonnageFinancialDetailTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'comprehensive-material'">
        <ng-container *ngTemplateOutlet="comprehensiveMaterialTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'tonnage-excel'">
        <ng-container *ngTemplateOutlet="tonnageExcelTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'tonnage-summary-excel'">
        <ng-container *ngTemplateOutlet="tonnageSummaryExcelTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'detailed-invoice'">
        <ng-container *ngTemplateOutlet="detailedInvoiceTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'transaction-report'">
        <ng-container *ngTemplateOutlet="transactionReportTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'invoice-aging'">
        <ng-container *ngTemplateOutlet="invoiceAgingTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'account-credit'">
        <ng-container *ngTemplateOutlet="accountCreditTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'customer-aging'">
        <ng-container *ngTemplateOutlet="customerAgingTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'invoice-aging-detail'">
        <ng-container *ngTemplateOutlet="invoiceAgingDetailTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'customer-statement'">
        <ng-container *ngTemplateOutlet="customerStatementTemplate; context: { isFavoriteSection: isFavoriteSection }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>


<!-- Report Templates -->

<!-- Tonnage Report Templates -->

    <!-- Tonnage Summary Report Template -->
    <ng-template #tonnageSummaryTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
            <button class="btn btn-sm fav-star"
            [ngClass]="{'btn-warning': isFavorite('tonnage-summary'), 'btn-outline-secondary': !isFavorite('tonnage-summary')}"
            (click)="toggleFavorite('tonnage-summary', 'Tonnage Summary Report')"
            [matTooltip]="isFavorite('tonnage-summary') ? 'Remove from favorites' : 'Add to favorites'"
            [matTooltipShowDelay]="tooltipDelay">
              <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Tonnage Summary Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Summary Report', 'MTSummary')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="summaryDateFrom ? (summaryDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (summaryDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #summaryDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="summaryDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
              (click)="summaryDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="summaryDateFrom = null; summaryDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!summaryDateFrom || !summaryDateTo" (click)="quickTonnageReportByDateRange('MTSummary');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of summaryReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of summaryReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Material Summary Report Template -->
    <ng-template #materialSummaryTemplate let-isFavoriteSection="isFavoriteSection">
    <div class="col col-item" style="position: relative;">
      <button class="btn btn-sm fav-star"
              [ngClass]="{'btn-warning': isFavorite('material-summary'), 'btn-outline-secondary': !isFavorite('material-summary')}"
              (click)="toggleFavorite('material-summary', 'Material Summary Report')"
              [matTooltip]="isFavorite('material-summary') ? 'Remove from favorites' : 'Add to favorites'"
              [matTooltipShowDelay]="tooltipDelay">
        <i class="fas fa-star"></i>
      </button>

      <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
        <h4>Material Summary Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchQuantitySummaryReportWizard('Quantity Summary Report', 'MatQtySummaryReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
      </div>

      <div class="centerRow">
        <div class="input-group" style="min-width: 25em; max-width: 40em;">
          <input
            [value]="MatQtySummaryDateFrom ? (MatQtySummaryDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (MatQtySummaryDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
            placeholder="Date Range" id="dateRange" name="dateRange" #matQtySummaryDateRange bsDaterangepicker
            [bsConfig]="bsConfig" (bsValueChange)="MatQuantitySummaryDateRangeChange($event)" class="form-control dateInput"
            [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

          <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
            (click)="matQtySummaryDateRange.click()">
            <i class="fas fa-calendar-week fa-lg"></i>
          </button>

          <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
            (click)="MatQtySummaryDateFrom = null; summaryDateTo = null;">
            <i class="fad fa-calendar fa-lg"></i>
          </button>

          <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!MatQtySummaryDateFrom || !MatQtySummaryDateTo" (click)="quickMatQtySummaryReportByDateRange('MatQtySummaryReport');">Quick Report</button>
        </div>
      </div>

      <div class="centerRow">
        <div class="buttonRow mt-2">
          <button *ngFor="let button of MatQtySummaryReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
            {{ button.text }}
          </button>
        </div>
      </div>

      <div class="centerRow">
        <div class="buttonRow mt-2">
          <button *ngFor="let button of MatQtySummaryReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
            {{ button.text }}
          </button>
        </div>
      </div>
    </div>
    </ng-template>

    <!-- Detailed Tonnage Report Template -->
    <ng-template #detailedTonnageTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('detailed-tonnage'), 'btn-outline-secondary': !isFavorite('detailed-tonnage')}"
                (click)="toggleFavorite('detailed-tonnage', 'Detailed Tonnage Report')"
                [matTooltip]="isFavorite('detailed-tonnage') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Detailed Tonnage Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Report', 'MTReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="detailedDateFrom ? (detailedDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (detailedDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #detailedDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="detailedDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
              (click)="detailedDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="detailedDateFrom = null; detailedDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!detailedDateFrom || !detailedDateTo" (click)="quickTonnageReportByDateRange('MTReport');">Quick Report</button>
          </div>
        </div>

        <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(detailedDateFrom, detailedDateTo)">
          <div style="width: 40em;">
            <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of detailedReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Material Quantity Report Template -->
    <ng-template #materialQuantityTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('material-quantity'), 'btn-outline-secondary': !isFavorite('material-quantity')}"
                (click)="toggleFavorite('material-quantity', 'Material Quantity Report')"
                [matTooltip]="isFavorite('material-quantity') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Material Quantity Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Material Quantity Report', 'QTYReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="quantityDateFrom ? (quantityDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (quantityDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #quantityDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="quantityDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
              (click)="quantityDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="quantityDateFrom = null; quantityDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!quantityDateFrom || !quantityDateTo" (click)="quickTonnageReportByDateRange('QTYReport');">Quick Report</button>
          </div>
        </div>

        <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(quantityDateFrom, quantityDateTo)">
          <div style="width: 40em;">
            <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of quantityReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Tonnage by Customer & Job Report Template -->
    <ng-template #tonnageByCustomerTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('tonnage-by-customer'), 'btn-outline-secondary': !isFavorite('tonnage-by-customer')}"
                (click)="toggleFavorite('tonnage-by-customer', 'Tonnage by Customer & Job')"
                [matTooltip]="isFavorite('tonnage-by-customer') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Tonnage by Customer & Job<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Report by Customer', 'CTReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="customerDateFrom ? (customerDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (customerDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #customerDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="customerDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
              (click)="customerDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="customerDateFrom = null; customerDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!customerDateFrom || !customerDateTo" (click)="quickTonnageReportByDateRange('CTReport');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of customerReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Annual Tonnage Report Template -->
    <ng-template #annualTonnageTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('annual-tonnage'), 'btn-outline-secondary': !isFavorite('annual-tonnage')}"
                (click)="toggleFavorite('annual-tonnage', 'Annual Tonnage Report')"
                [matTooltip]="isFavorite('annual-tonnage') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Annual Tonnage Report</h4>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of annualReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Annual Grid Tonnage Report Template -->
    <ng-template #annualGridTonnageTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('annual-grid-tonnage'), 'btn-outline-secondary': !isFavorite('annual-grid-tonnage')}"
                (click)="toggleFavorite('annual-grid-tonnage', 'Annual Grid Tonnage Report')"
                [matTooltip]="isFavorite('annual-grid-tonnage') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Annual Grid Tonnage Report</h4>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of annualGridReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #annualCompTonnageReport let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('annual-comp-tonnage'), 'btn-outline-secondary': !isFavorite('annual-comp-tonnage')}"
                (click)="toggleFavorite('annual-comp-tonnage', 'Comprehensive Annual Material Report')"
                [matTooltip]="isFavorite('annual-comp-tonnage') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Comprehensive Annual Material Report</h4>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of comprehensiveAnnualReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Seasonal Tonnage Report Template -->
    <ng-template #seasonalTonnageTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('seasonal-tonnage'), 'btn-outline-secondary': !isFavorite('seasonal-tonnage')}"
                (click)="toggleFavorite('seasonal-tonnage', 'Seasonal Tonnage Report')"
                [matTooltip]="isFavorite('seasonal-tonnage') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Seasonal Tonnage Report</h4>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of seasonalReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Seasonal Tonnage Excel Report Template -->
    <ng-template #seasonalTonnageExcelTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('seasonal-tonnage-excel'), 'btn-outline-secondary': !isFavorite('seasonal-tonnage-excel')}"
                (click)="toggleFavorite('seasonal-tonnage-excel', 'Seasonal Tonnage Excel Report')"
                [matTooltip]="isFavorite('seasonal-tonnage-excel') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Seasonal Tonnage Excel Report</h4>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of seasonalExcelReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

<!-- Tonnage Financial Templates -->

    <!-- Tonnage Financial Detail Report Template -->
    <ng-template #tonnageFinancialDetailTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('tonnage-financial-detail'), 'btn-outline-secondary': !isFavorite('tonnage-financial-detail')}"
                (click)="toggleFavorite('tonnage-financial-detail', 'Tonnage Financial Detail Report')"
                [matTooltip]="isFavorite('tonnage-financial-detail') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Tonnage Financial Detail<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Financial Detail Report', 'TReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="incomeDateFrom ? (incomeDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (incomeDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #incomeDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="incomeDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Income Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set an income date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set an income date range filter" type="button"
              (click)="incomeDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="incomeDateFrom = null; incomeDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!incomeDateFrom || !incomeDateTo" (click)="quickTonnageReportByDateRange('TReport');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of incomeReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Comprehensive Material Report Template -->
    <ng-template #comprehensiveMaterialTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('comprehensive-material'), 'btn-outline-secondary': !isFavorite('comprehensive-material')}"
                (click)="toggleFavorite('comprehensive-material', 'Comprehensive Material Report')"
                [matTooltip]="isFavorite('comprehensive-material') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Comprehensive Material Summary<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Comprehensive Material Report', 'CMSummary')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="comprehensiveDateFrom ? (comprehensiveDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (comprehensiveDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #comprehensiveDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="comprehensiveDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Comprehensive Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a comprehensive report date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a comprehensive report date range filter" type="button"
              (click)="comprehensiveDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="comprehensiveDateFrom = null; comprehensiveDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!comprehensiveDateFrom || !comprehensiveDateTo" (click)="quickTonnageReportByDateRange('CMSummary');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of comprehensiveReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of comprehensiveReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Tonnage Excel Report Template -->
    <ng-template #tonnageExcelTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('tonnage-excel'), 'btn-outline-secondary': !isFavorite('tonnage-excel')}"
                (click)="toggleFavorite('tonnage-excel', 'Tonnage Excel Report')"
                [matTooltip]="isFavorite('tonnage-excel') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Tonnage Excel Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Excel Report', 'EReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="excelDateFrom ? (excelDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (excelDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #excelDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="excelDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Excel Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set an excel report date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set an excel report date range filter" type="button"
              (click)="excelDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="excelDateFrom = null; excelDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!excelDateFrom || !excelDateTo" (click)="quickTonnageReportByDateRange('EReport');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of excelReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of excelReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Tonnage Summary Excel Report Template -->
    <ng-template #tonnageSummaryExcelTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('tonnage-summary-excel'), 'btn-outline-secondary': !isFavorite('tonnage-summary-excel')}"
                (click)="toggleFavorite('tonnage-summary-excel', 'Tonnage Summary Excel Report')"
                [matTooltip]="isFavorite('tonnage-summary-excel') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Tonnage Summary Excel<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Summary Excel Report', 'TSEReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="tonnageSummaryExcelDateFrom ? (tonnageSummaryExcelDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (tonnageSummaryExcelDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #tonnageSummaryExcelDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="tonnageSummaryExcelDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Tonnage Summary Excel Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a tonnage summary excel date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a tonnage summary excel date range filter" type="button"
              (click)="tonnageSummaryExcelDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="tonnageSummaryExcelDateFrom = null; tonnageSummaryExcelDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!tonnageSummaryExcelDateFrom || !tonnageSummaryExcelDateTo" (click)="quickTonnageReportByDateRange('TSEReport');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of tonnageSummaryExcelReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of tonnageSummaryExcelReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

<!-- Finance Report Templates -->

    <!-- Detailed Invoice Report Template -->
    <ng-template #detailedInvoiceTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('detailed-invoice'), 'btn-outline-secondary': !isFavorite('detailed-invoice')}"
                (click)="toggleFavorite('detailed-invoice', 'Detailed Invoice Report')"
                [matTooltip]="isFavorite('detailed-invoice') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Detailed Invoice Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomInvoiceReportBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="invoiceDateFrom ? (invoiceDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (invoiceDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #invoiceDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="invoiceDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
              (click)="invoiceDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="invoiceDateFrom = null; invoiceDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!invoiceDateFrom || !invoiceDateTo" (click)="quickInvoiceReportByDateRange('STLReport');">Quick Report</button>
          </div>
        </div>

        <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(invoiceDateFrom, invoiceDateTo)">
          <div style="width: 40em;">
            <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of invoiceReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Transaction Report Template -->
    <ng-template #transactionReportTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('transaction-report'), 'btn-outline-secondary': !isFavorite('transaction-report')}"
                (click)="toggleFavorite('transaction-report', 'Transaction Report')"
                [matTooltip]="isFavorite('transaction-report') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Transaction Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomTransactionReportBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

        <div class="centerRow">
          <div class="input-group" style="min-width: 25em; max-width: 40em;">
            <input
              [value]="transactionDateFrom ? (transactionDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (transactionDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
              placeholder="Date Range" id="dateRange" name="dateRange" #transactionDateRange bsDaterangepicker
              [bsConfig]="bsConfig" (bsValueChange)="transactionDateRangeChange($event)" class="form-control dateInput"
              [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

            <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
              (click)="transactionDateRange.click()">
              <i class="fas fa-calendar-week fa-lg"></i>
            </button>

            <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
              (click)="transactionDateFrom = null; transactionDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>

            <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!transactionDateFrom || !transactionDateTo" (click)="quickTransactionReportByDateRange('TransactionReport');">Quick Report</button>
          </div>
        </div>

        <div class="centerRow">
          <div class="buttonRow mt-2">
            <button *ngFor="let button of transactionMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
              {{ button.text }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Invoice Aging Report Template -->
    <ng-template #invoiceAgingTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('invoice-aging'), 'btn-outline-secondary': !isFavorite('invoice-aging')}"
                (click)="toggleFavorite('invoice-aging', 'Invoice Aging Report')"
                [matTooltip]="isFavorite('invoice-aging') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Invoice Aging Report</h4>
        </div>

        <div class="d-flex justify-content-center">
            <button class="btn btn-success" [ngClass]="{'btn-dark': darkMode}" (click)="generateInvoiceAgingReport();">Generate Report</button>
        </div>
      </div>
    </ng-template>

    <!-- Account Credit Report Template -->
    <ng-template #accountCreditTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('account-credit'), 'btn-outline-secondary': !isFavorite('account-credit')}"
                (click)="toggleFavorite('account-credit', 'Account Credit Report')"
                [matTooltip]="isFavorite('account-credit') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Account Credit Report</h4>
        </div>

        <div class="d-flex justify-content-center">
          <button class="btn btn-success" [ngClass]="{'btn-dark': darkMode}" (click)="generateAccountCreditReport();">Generate Report</button>
        </div>
      </div>
    </ng-template>

    <!-- Customer Aging Report Template -->
    <ng-template #customerAgingTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('customer-aging'), 'btn-outline-secondary': !isFavorite('customer-aging')}"
                (click)="toggleFavorite('customer-aging', 'Customer Aging Report')"
                [matTooltip]="isFavorite('customer-aging') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Customer Aging Report</h4>
        </div>

        <div class="d-flex justify-content-center">
          <button class="btn btn-success" [ngClass]="{'btn-dark': darkMode}" (click)="generateCustomerAgingReport();">Generate Report</button>
        </div>

      </div>
    </ng-template>

    <!-- Invoice Aging Detail Report Template -->
    <ng-template #invoiceAgingDetailTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('invoice-aging-detail'), 'btn-outline-secondary': !isFavorite('invoice-aging-detail')}"
                (click)="toggleFavorite('invoice-aging-detail', 'Invoice Aging Detail Report')"
                [matTooltip]="isFavorite('invoice-aging-detail') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Invoice Aging Detail Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomAgingDetailBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>

      </div>
    </ng-template>

    <!-- Customer Statement Report Template -->
    <ng-template #customerStatementTemplate let-isFavoriteSection="isFavoriteSection">
      <div class="col col-item" style="position: relative;">
        <button class="btn btn-sm fav-star"
                [ngClass]="{'btn-warning': isFavorite('customer-statement'), 'btn-outline-secondary': !isFavorite('customer-statement')}"
                (click)="toggleFavorite('customer-statement', 'Customer Statement Report')"
                [matTooltip]="isFavorite('customer-statement') ? 'Remove from favorites' : 'Add to favorites'"
                [matTooltipShowDelay]="tooltipDelay">
          <i class="fas fa-star"></i>
        </button>

        <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
          <h4>Customer Statement Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomerStatementReportBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
        </div>
      </div>
    </ng-template>

<!-- End of ng-template definitions -->

  </div>
</div>


<!-- OLD Non template version of reports. -->
    <!-- Tonnage Reports Start -->
<!--
    <div style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseTonnage}">
      <div style="text-align: center; margin: 1em;">
        <h1>Tonnage Reports</h1>
      </div>
      <button class="btn btn-sm"
            [ngClass]="{'darkMode': darkMode}"
            style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;"
            (click)="collapseTonnage = !collapseTonnage;">
            <i class="fal" [ngClass]="{'fa-angle-up': collapseTonnage, 'fa-angle-down': !collapseTonnage}"></i>
          </button>
      <hr>

      <div class="container" style="max-width: 93%;">

        <div class="reports-grid">

          <div class="col col-item">

            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Tonnage Summary Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Summary Report', 'MTSummary')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="summaryDateFrom ? (summaryDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (summaryDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #summaryDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="summaryDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="summaryDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="summaryDateFrom = null; summaryDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!summaryDateFrom || !summaryDateTo" (click)="quickTonnageReportByDateRange('MTSummary');">Quick Report</button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of summaryReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of summaryReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Material Summary Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchQuantitySummaryReportWizard('Quantity Summary Report', 'MatQtySummaryReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="MatQtySummaryDateFrom ? (MatQtySummaryDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (MatQtySummaryDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #matQtySummaryDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="MatQuantitySummaryDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="matQtySummaryDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="MatQtySummaryDateFrom = null; summaryDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!MatQtySummaryDateFrom || !MatQtySummaryDateTo" (click)="quickMatQtySummaryReportByDateRange('MatQtySummaryReport');">Quick Report</button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of MatQtySummaryReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of MatQtySummaryReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>


          <div class="col col-item">

            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Detailed Tonnage Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Report', 'MTReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="detailedDateFrom ? (detailedDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (detailedDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #detailedDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="detailedDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="detailedDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="detailedDateFrom = null; detailedDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!detailedDateFrom || !detailedDateTo" (click)="quickTonnageReportByDateRange('MTReport');">Quick Report</button>
              </div>
            </div>

            <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(detailedDateFrom, detailedDateTo)">
              <div style="width: 40em;">
                <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of detailedReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Material Quantity Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Material Quantity Report', 'QTYReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="quantityDateFrom ? (quantityDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (quantityDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #quantityDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="quantityDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="quantityDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="quantityDateFrom = null; quantityDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!quantityDateFrom || !quantityDateTo" (click)="quickTonnageReportByDateRange('QTYReport');">Quick Report</button>
              </div>
            </div>

            <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(quantityDateFrom, quantityDateTo)">
              <div style="width: 40em;">
                <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of quantityReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Tonnage by Customer & Job<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Report by Customer', 'CTReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="customerDateFrom ? (customerDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (customerDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #customerDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="customerDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="customerDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="customerDateFrom = null; customerDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!customerDateFrom || !customerDateTo" (click)="quickTonnageReportByDateRange('CTReport');">Quick Report</button>
              </div>
            </div>

            <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(customerDateFrom, customerDateTo)">
              <div style="width: 40em;">
                <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of customerReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Annual Tonnage Report</h4>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-3">
                <button *ngFor="let button of annualReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" [style]="button.active ? '' : 'display: none;'" (click)="button.clickEvent()">{{ button.text }}</button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Annual Grid Tonnage Report</h4>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-3">
                <button *ngFor="let button of annualGridReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" [style]="button.active ? '' : 'display: none;'" (click)="button.clickEvent()">{{ button.text }}</button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Seasonal Tonnage Report</h4>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-3">
                <button *ngFor="let button of seasonalReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" [style]="button.active ? '' : 'display: none;'" (click)="button.clickEvent()">{{ button.text }}</button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Seasonal Tonnage Excel Report</h4>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-3">
               <button *ngFor="let button of seasonalExcelReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" [style]="button.active ? '' : 'display: none;'" (click)="button.clickEvent()">{{ button.text }}</button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <br>
    </div>
  -->
    <!-- Tonnage Financial Reports Start -->
<!--
    <div style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseTonFinance}">
      <div style="text-align: center; margin: 1em;">
        <h1>Tonnage Financial Reports</h1>
      </div>
      <button class="btn btn-sm" [ngClass]="{'darkMode': darkMode}" style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;" (click)="collapseTonFinance = !collapseTonFinance;"><i class="fal" [ngClass]="{'fa-angle-up': collapseTonFinance, 'fa-angle-down': !collapseTonFinance}"></i></button>
      <hr>

      <div class="container" style="max-width: 93%;">
        <div class="reports-grid">
          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Tonnage Financial Detail<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Report with Price', 'TReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="incomeDateFrom ? (incomeDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (incomeDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #incomeDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="incomeDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="incomeDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="incomeDateFrom = null; incomeDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!incomeDateFrom || !incomeDateTo" (click)="quickTonnageReportByDateRange('TReport');">Quick Report</button>
              </div>
            </div>

            <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(incomeDateFrom, incomeDateTo)">
              <div style="width: 40em;">
                <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of incomeReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Comprehensive Material Summary<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Comprehensive Material Report', 'CMSummary')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="comprehensiveDateFrom ? (comprehensiveDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (comprehensiveDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #comprehensiveDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="comprehensiveDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="comprehensiveDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="comprehensiveDateFrom = null; comprehensiveDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!comprehensiveDateFrom || !comprehensiveDateTo" (click)="quickTonnageReportByDateRange('CMSummary');">Quick Report</button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of comprehensiveReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of comprehensiveReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Tonnage Excel Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Excel Report', 'EReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="excelDateFrom ? (excelDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (excelDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #excelDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="excelDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="excelDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="excelDateFrom = null; excelDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!excelDateFrom || !excelDateTo" (click)="quickTonnageReportByDateRange('EReport');">Quick Report</button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of excelReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of excelReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Tonnage Summary Excel Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchTonnageReportWizard('Tonnage Summary Excel Report', 'TSEReport')"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em;">
                <input
                  [value]="tonnageSummaryExcelDateFrom ? (tonnageSummaryExcelDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (tonnageSummaryExcelDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #tonnageSummaryExcelDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="tonnageSummaryExcelDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="tonnageSummaryExcelDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="tonnageSummaryExcelDateFrom = null; tonnageSummaryExcelDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!tonnageSummaryExcelDateFrom || !tonnageSummaryExcelDateTo" (click)="quickTonnageReportByDateRange('TSEReport');">Quick Report</button>
              </div>
            </div>

            <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(tonnageSummaryExcelDateFrom, tonnageSummaryExcelDateTo)">
              <div style="width: 40em;">
                <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of tonnageSummaryExcelReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of tonnageSummaryExcelReportYearButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <br>
    </div> -->
    <!-- Tonnage Financial Reports End -->
    <!-- Finance Reports Start -->
<!--
    <div style="width: 95%; margin: auto; border: solid 2px; margin-top: 0.5em;" [ngClass]="{'collapse-report-section': collapseInvoice}">
      <div style="text-align: center; margin: 1em;">
        <h1>Finance Reports</h1>
      </div>
      <button class="btn btn-sm" [ngClass]="{'darkMode': darkMode}" style="float: right; font-size: 3rem; margin-top: -1.75em; margin-right: 1em;" (click)="collapseInvoice = !collapseInvoice;"><i class="fal" [ngClass]="{'fa-angle-up': collapseInvoice, 'fa-angle-down': !collapseInvoice}"></i></button>
      <hr>

      <div class="container" style="max-width: 93%;">
        <div class="reports-grid">
          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Detailed Invoice Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomInvoiceReportBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="invoiceDateFrom ? (invoiceDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (invoiceDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #invoiceDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="invoiceDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="invoiceDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="invoiceDateFrom = null; invoiceDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!invoiceDateFrom || !invoiceDateTo" (click)="quickInvoiceReportByDateRange('STLReport');">Quick Report</button>
              </div>
            </div>

            <div class="row mt-2 mb-2 text-center" style="justify-content: center;" *ngIf="displayDateRangeWarning(invoiceDateFrom, invoiceDateTo)">
              <div style="width: 40em;">
                <small style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</small>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of invoiceReportMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Transaction Report<button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomTransactionReportBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>

            <div class="centerRow">
              <div class="input-group" style="min-width: 25em; max-width: 40em;">
                <input
                  [value]="transactionDateFrom ? (transactionDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (transactionDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
                  placeholder="Date Range" id="dateRange" name="dateRange" #transactionDateRange bsDaterangepicker
                  [bsConfig]="bsConfig" (bsValueChange)="transactionDateRangeChange($event)" class="form-control dateInput"
                  [ngClass]="{'btn-dark': darkMode}" aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">

                <button class="btn" [ngClass]="{'btn-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter" type="button"
                  (click)="transactionDateRange.click()">
                  <i class="fas fa-calendar-week fa-lg"></i>
                </button>

                <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode && !glassMode, 'btn-dark': darkMode}"
                  [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button" style="border-top-right-radius: 0.375rem; border-bottom-right-radius: 0.375rem;"
                  (click)="transactionDateFrom = null; transactionDateTo = null;">
                  <i class="fad fa-calendar fa-lg"></i>
                </button>

                <button class="ms-2 btn btn-success quickReportBtn" [ngClass]="{'btn-dark': darkMode}" [disabled]="!transactionDateFrom || !transactionDateTo" (click)="quickTransactionReportByDateRange('TransactionReport');">Quick Report</button>
              </div>
            </div>

            <div class="centerRow">
              <div class="buttonRow mt-2">
                <button *ngFor="let button of transactionMonthButtons" [class]="'btn ' + button.class" [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>

          <div class="col col-item">
              <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
                  <h4>Invoice Aging Report</h4>
              </div>

              <div class="d-flex justify-content-center">
                  <button class="btn btn-success" [ngClass]="{'btn-dark': darkMode}" (click)="generateInvoiceAgingReport();">Generate Report</button>
              </div>
          </div>

          <div class="col col-item" *ngIf="appGlobals.site && appGlobals.site.paymentsActive">
              <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
                  <h4>Account Credit Report</h4>
              </div>

              <div class="d-flex justify-content-center">
                  <button class="btn btn-success" [ngClass]="{'btn-dark': darkMode}" (click)="generateAccountCreditReport();">Generate Report</button>
              </div>
          </div>

          <div class="col col-item" *ngIf="appGlobals.site && appGlobals.site.paymentsActive">
              <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
                  <h4>Customer Aging Report</h4>
              </div>

              <div class="d-flex justify-content-center">
                  <button class="btn btn-success" [ngClass]="{'btn-dark': darkMode}" (click)="generateCustomerAgingReport();">Generate Report</button>
              </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Invoice Aging Detail Report <button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomAgingDetailBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>
          </div>

          <div class="col col-item">
            <div style="text-align: center; margin-top: 2em; margin-bottom: 1em;">
              <h4>Customer Statement <button class="btn btn-primary ms-3"[ngClass]="{'btn-dark': darkMode}" (click)="launchCustomerStatementReportBuilder()"><i class="fal fa-file-alt fa-lg"></i>Custom Report</button></h4>
            </div>
          </div>

        </div>
      </div>
      <br>
    </div> -->
    <!-- Finance Reports End -->


